import { T }    from 'defa-object';
import template from './accessoryDetailsView.jst.html'

/**
 * defa.views.Accessory
 * A description.
 * @version 0.1
 */
import View     from 'scripts/poppet/view';

const selectors = {
	buttonClose   : '[data-click=close]',
	buttonRemove  : '[data-click=remove]',
	select        : '[data-input=select-input]',
	selectZone    : '[data-input=select-zone-input]',
	errorText     : '[data-text=accessory-error]'
	
};

const AccessoryDetailsView = View.extend( {
	
	// ------------------------------------------------
	// Setup
	// ------------------------------------------------
	
	template  : template,
	className : 'unit-accessory-details',
	
	ui: {
		close        : selectors.buttonClose,
		remove       : selectors.buttonRemove,
		selectConfig : selectors.select,
		selectZone   : selectors.selectZone,
		error        : selectors.errorText
	},

	events: {
		'click         @ui.close' : 'onClickClose',
		'click         @ui.remove': 'onClickRemove',
		'input         @ui.selectConfig' : 'onClickConfig',
		'input         @ui.selectZone' : 'onClickSelectZone',
	},
	modelEvents:{
		'change': 'render',
	},

	templateContext: function () {
		return {
			getId         : this.model.getId(),
			datetime      : this.model.getDateTime(),
			level         : this.getBatteryLevel(),
			type          : this.getType(),
			hasConfig     : this.hasConfig(),
			hasZoneSetting: this.hasZoneSetting(),
			getConfig     : this.getCurrentConfig(),
		};
	},
	
	/**
	 * Triggers when the end user clicks the close button.
	 * @void
	 */
	onClickClose: function () {
		this.trigger('accessory:close', this.model);
	},
	
	/**
	 * Triggers when the end user clicks the remove button.
	 * @void
	 */
	onClickRemove: function () {
		let self = this;
		self.busy();
		this.trigger(
			'remove:accessory',
			this.model,
			{
				success: function () {
					console.log( 'remoteUnpairUnit success' );
					self.idle();
				},
				error: function (error) {
					self.idle();
					console.error( 'remoteUnpairUnit failed' );
					self.showError(error);
				}
			}
		);
	
	},
	
	/**
	 * DimplexType = 1, DigiHeat8
	 * DimplexType = 2, Orion700
	 */
	onClickConfig: function () {
		let self = this;
		let selectConfig = document.getElementById('select-input');
		let setConfig = selectConfig.options[selectConfig.selectedIndex].text;
		self.busy();
		
		if ('DigiHeat 8' === setConfig) {
			this.model.set({dimplexType: 1});
		} else {
			this.model.set({dimplexType: 2});
		}
		this.trigger(
			'save:config',
			this.model,
			{
				success: function () {
					console.log( 'saveDimplex: writeWirelessSetting success!' );
					self.idle();
				},
				error: function (error) {
					self.idle();
					console.error( 'saveDimplex: writeWirelessSetting failed' );
					self.showError(error);
				}
			}
		);
	},

	onClickSelectZone: function () {
		let self = this;
		let selectZone = document.getElementById('select-zone-input');
		let setZone = selectZone.options[selectZone.selectedIndex].value;
		this.model.set({zone: setZone });
		self.busy();
		this.trigger(
			'save:zone',
			this.model,
			{
				success: function () {
					console.log( 'saveZone: writeWirelessSetting success!' );
					self.idle();
				},
				error: function (error) {
					self.idle();
					console.error( 'saveZone: writeWirelessSetting error!' );
					self.showError(error);
				}
			}
		);
	},

	/**
	 * Gets the battery level
	 * 0 = Unknown, 1 = Low, 2 = Normal, 3 = High.
	 * @string
	 */
	getBatteryLevel: function ( ) {
		let level = this.model.get('batteryLevel');
		switch ( level ) {
			case 0:
				return;
			case 1:
				return 'Low';
			case 2:
				return 'Normal';
			case 3:
				return 'High';
		}
	},
	
	/**
	 * Gets the type of accessory for description
	 * @string
	 */
	getType: function( ){
		let tempType = this.model.get('deviceType');
		switch ( tempType ) {
			case 0: // UNDEFINED
				return;
			case 1: // MOTION
				return T.tc('ControlAccessories','is a wireless passive infrared detector (PIR) which will detect movement in a room and send you an alert. This detector will be assigned to the alarm zone.');
			case 2: // CONTACT
				return T.tc('ControlAccessories','is a wireless door/window magnet which will detect breach in a perimeter and send you an alert. This detector will be assigned to the alarm zone.');
			case 3: // SMOKE
				return T.tc('ControlAccessories','is a wireless smoke detector which will go off when smoke is detected and send you an alert. This detector will be assigned to the alarm zone, and will not follow the alarm on/off switch.');
			case 4: // TIPPER
				return T.tc('ControlAccessories','is a wirelessly controlled three-relay unit for remote control of fixed circuits . You can change zones on this product by regulating its physical zone selector.');
			case 5: // DIMPLEX
				return T.tc('ControlAccessories','is a remote control unit for Nobø EC-700 or DigiHeat 8. Please choose which Glen Dimplex unit you wish to remote control.');
			case 6: // TEMPERATURE
				return T.tc('ControlAccessories','is a wireless temperature sensor for reading temperatures and also using them for thermostat control. You can change zones on this product by regulating its physical zone selector.');
			case 7: // NOBO
				return T.tc('ControlAccessories','supports wireless control of Nobø TRB floor heating and RXC/RDC oven plug thermostats. Please choose which zone to assign to this thermostat.');
			case 8: // SOCKET
				return T.tc('ControlAccessories','is a wireless wall socket for remote control of electrical appliances. You can change zones on this product by regulating its physical zone selector.');
			case 80: // BASE
				return;
		}
	},
	
	getCurrentConfig: function() {
		if ( 1 === this.model.get('dimplexType')) {
			return 'DigiHeat 8'
		} else if (2 === this.model.get('dimplexType')) {
			return 'Orion 700'
		}
	},

	/**
	 * Informs if we should show 'Select configuration' or not.
	 * @return {boolean} True if the type is 'Dimplex Adapter', false if not.
	 */
	hasConfig: function() {
		return 	(5 === this.model.get('deviceType'))
	},
	
	hasZoneSetting: function() {
		return (7 === this.model.get('deviceType'))
	},
	
	showError: function (error) {
		this.ui.error.removeAttr('hidden');
		this.ui.error.html(error)
	}

} );

export default AccessoryDetailsView;
